<p-menu
  [model]="model"
  [popup]="popup"
  [style]="style"
  [styleClass]="styleClass"
  [appendTo]="appendTo"
  [autoZIndex]="autoZIndex"
  [baseZIndex]="baseZIndex"
  [showTransitionOptions]="showTransitionOptions"
  [hideTransitionOptions]="hideTransitionOptions"
  #menu>
  <!-- Template Start -->
  @if (startTemplate ?? _startTemplate) {
    <ng-template pTemplate="start">
      <ng-container *ngTemplateOutlet="startTemplate ?? _startTemplate" />
    </ng-template>
  }

  <!-- Template Item -->
  <ng-template pTemplate="item" let-item>
    @if (isCheckable(item)) {
      <div [cesCheckableMenuItem]="item" [parentModel]="model" class="p-menu-item-content">
        <a [attr.data-pc-section]="'action'" [attr.href]="item.url || null" class="p-menu-item-link" [attr.target]="item.target">
          <p-checkbox
            [binary]="true"
            [ngModel]="item.checked"
            [readonly]="true"
            class="p-menu-checkbox-icon pointer-events-none"
            (click)="$event.stopPropagation()" />
          <span class="p-menu-item-text">{{ item.label }}</span>
        </a>
      </div>
    } @else {
      <div class="p-menu-item-content">
        <a [attr.data-pc-section]="'action'" [attr.href]="item.url || null" class="p-menu-item-link" [attr.target]="item.target">
          @if (item.icon) {
            <span class="p-menu-item-icon" [ngClass]="item.icon"></span>
          }
          <span class="p-menu-item-text">{{ item.label }}</span>
        </a>
      </div>
    }
  </ng-template>

  <!-- Template End -->
  @if (endTemplate ?? _endTemplate) {
    <ng-template pTemplate="end">
      <ng-container *ngTemplateOutlet="endTemplate ?? _endTemplate" />
    </ng-template>
  }
</p-menu>
